module.exports = __webpack_public_path__ + "d4e94ba327b96a5b3f2521d43c60309e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/feature01.png
// module id = 799
// module chunks = 3